import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import FormSection from './FormSection';
import StundentDataHeader from './StundentDataHeader';
import { useDispatch } from 'react-redux';
import { getCountryCodeAndCountry, getNonCartStudentData } from '../../../../../redux/features/CRDslice';
import { useSelector } from 'react-redux';
import Loader3D from '../../../../../components/Loader/Loader3D';

const FormDataPrefill = ({ rowData, setOpen }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.crd);

  useEffect(() => {
    if (rowData?.course_enrollment_id) {
      dispatch(getNonCartStudentData(rowData?.course_enrollment_id));
      dispatch(getCountryCodeAndCountry());
    }
  }, []);
  return (
    <>
      {loading ? (
        <Loader3D />
      ) : (
        <Box>
          <StundentDataHeader />
          <FormSection setOpen={setOpen} />
        </Box>
      )}
    </>
  );
};

export default FormDataPrefill;
